<template>
  <div class="home">
    <router-view />
    <TheFooter />
  </div>
</template>

<script>
import TheFooter from "@/components/footer/TheFooter.vue";

export default {
  name: "Home",

  components: {
    TheFooter
  }
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: calc(100% - #{$footerHeight});
}
</style>
